import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';
import { canPerformAction } from './validators/functions/can-perform-action.function';

export * from './dtos/create-asset-reservation.dto';
export * from './dtos/asset-reservation-links.dto';
export * from './dtos/asset-reservation-list.dto';
export * from './dtos/asset-reservation-record.dto';
export * from './dtos/asset-reservation-search.dto';
export * from './dtos/asset-reservations-stats.dto';
export * from './dtos/update-asset-reservation.dto';

export * from './enums/asset-reservation-action.enum';
export * from './enums/asset-reservation-status.enum';

export * from './functions/asset-reservation-status-to-color.function';

export * from './types/asset-reservations-filters';

export * from './validators/schemas/create-asset-reservation.schema';
export * from './validators/schemas/update-asset-reservation.schema';

export const assetReservationValidators = {
	canCreateOrUpdate,
	canPerformAction,
};
